import React from "react";
import { connect } from "react-redux";
import { Warning } from "@material-ui/icons";
import Enumerable from "linq";

const SegmentValidationPresenter = (props) => {
  let svr = Object.values(props.SegmentValidationResult);
  let validatedSegment = Enumerable.from(svr).firstOrDefault((x) => x.targetId === props.segment.TargetId);
  let strings = convertSvrToStrings(validatedSegment);
  let is_critical = validatedSegment.missingTags || validatedSegment.incorrectTagOrder || validatedSegment.differentTags;
  return (
    <div>
      <table>
        <colgroup>
          <col width={30} />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <td>
              {validatedSegment.state === 2 && validatedSegment.numerOfWarnings === 1 && validatedSegment.differentTagSpaces ? null : validatedSegment.state !== 1 ? (
                <Warning style={{ color: is_critical ? "red" : undefined }}></Warning>
              ) : null}
            </td>
            <td>
              <ul>
                {strings.map((x, index) => (
                  <li key={index}>{x}</li>
                ))}
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};
export default connect(mapStateToProps)(SegmentValidationPresenter);

function convertSvrToStrings(svr) {
  let strings = [];
  //if (svr.__clientside__UNIDENTIFIED_ERROR) strings.push("Unable to save translation. Please, check your internet connection.");
  if (svr.differentLeadingSpaces) strings.push("Different leading spaces");
  if (svr.differentTagSpaces) strings.push("Different tag spaces");
  if (svr.differentTags) strings.push("Different tags");
  if (svr.differentTagsNesting) strings.push("Different tags nesting");
  if (svr.draft) strings.push("Draft");
  if (svr.hasDoubleSpaces) strings.push("Has double spaces");
  if (svr.hasLineBreak) strings.push("Has line break");
  if (svr.incorrectTagOrder) strings.push("Incorrect tag order");
  if (svr.isEmpty) strings.push("Empty");
  if (svr.maxLengthExceeded) strings.push("Max length exceeded");
  if (svr.missingTags) strings.push("Missing tags");
  if (svr.numericMismatch) strings.push("Numeric mismatch");
  if (svr.placeholdersMismatch) strings.push("Placeholder mismatch");
  if (svr.possibleIncorrectTagOrer) strings.push("Possible incorrect tag order");
  if (svr.repeatedWords) strings.push("Repeated words");
  if (svr.specialCharsMismatch) strings.push("Special characters mismatch");
  if (svr.differentTrailingSpaces) strings.push("Different trailing spaces");
  if (svr.extraPeriod) strings.push("Extra period");
  if (svr.missingPeriod) strings.push("Missing period");
  if (svr.possibleIncorrectTagOrder) strings.push("Possible incorrect tag order");
  return strings;
}
